export default __webpack_public_path__ + "static/media/diskette.2361e744.png";